export default __webpack_public_path__ + "static/media/Back-arrow-white.3fc5fd23.svg";